<template>
	<div class="data16" :style="{
	 marginTop:list.is_top?'':'-149px'
 }">
		<div class="data16Bg" :style="{
				backgroundImage:`url('${list.data.bg_cover}')`,
			}">
			<!-- :style="{
				backgroundImage:`url('${list.data.bg_cover}')`,
			}" -->
	<!-- https://aohuacbi.oss-cn-qingdao.aliyuncs.com/20230511/%E7%9F%A9%E5%BD%A2%20525%403x%20(10).png -->
			<div class="data16Img">
				<img :src="list.data.bg_cover1" v-if="list.data.bg_cover1" />
				<img src="@/assets/product/cgq/cp4k.png" v-else />
			</div>
			<div class="data16Wz">
				<div class="data16WzTil">{{list.data.title}}</div>
				<div class="data16WzCen">
					{{list.data.desc}}
				</div>
			</div>
			<div class="data16BgSp">
				<!-- <img src="@/assets/product/page6/sp.png" /> -->
				<div class="swiper-data2-banner" :class="`swiper-data2-banner${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in list.data.urls" :key="index">
							<img :src="item" v-if="!list.data.type||list.data.type==1"></img>
							<!-- <video :src="item" v-else :autoplay="true" muted loop></video> -->
							
							<template v-else>
								<template v-if="headerShow">
									<video :src="item" :autoplay="true" muted loop webkit-playsinline playsinline x5-video-player-type="h5-page"></video>
								</template>
								<template v-else>
									<video :src="item"  muted loop webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto" :poster="item+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
								</template>
							</template>
						</div>
					</div>
				</div>
			</div>
			<div class="data16BgSpList">
				<div class="swiper-canpin" :class="`swiper-canpin${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide swiper-slide-Two" v-for="(item,index) in list.data.images" :key="index">
							<div class="data16BgSpListFor">
								<img :src="item" />
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="data16BgSpListFor" v-for="(item,index) in list.data.images" :key="index">
					<img :src="item" />
				</div> -->
			</div>
		</div>
		<component :is="mapComponent[list.valueTwo]" :list='list' :ref="list.valueTwo" @goScroll='goScroll' />
	</div>
</template>

<script>
	import mapComponent from "@/components/mapComponentTwo.js";
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				mapComponent,
				img4kBj: require("@/assets/product/page6/beijin.png"),
				spImgList: [{
						img: require("@/assets/product/page6/img1.png")
					},
					{
						img: require("@/assets/product/page6/img2.png")
					},
					{
						img: require("@/assets/product/page6/img3.png")
					},
					{
						img: require("@/assets/product/page6/img4.png")
					},
				],


			}
		},
		mounted() {
			let t = this
			let name='.swiper-data2-banner'+this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				slidesPerView: 1,
				allowTouchMove: this.list.data.urls.length > 1 ? true : false,
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},

				},
			});
			let nameTwo='.swiper-canpin'+this.list.index;
			const mySwiperTwo = new this.$swiper(nameTwo, {
				// 方向
				direction: 'horizontal',
				slidesPerView: 'auto', // 每屏显示3个滑块
				slidesPerGroup: 1, // 每次滑动3个滑块
				spaceBetween:30,
				allowTouchMove: this.list.data.images.length > 1 ? true : false,
				freeMode: false,
				// 自动播放
				autoplay: false,
			});
		},
		methods: {
			goScroll(e) {
				this.$emit('goScroll', e)
				// document.documentElement.scrollTop = offsetTop+10;
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data16Bg {
		width: 100%;
		height: 2678px;
		// background-size: cover;
		background-position: top center;
		display: flex;
		flex-direction: column;
		background-image: url("~@/assets/product/cgq/cp4kbg.png");
		background-repeat: repeat-y;
		min-width: 1200px;
		margin-bottom: 150px;
		.data16Img{
			width: 100%;
			max-width: 1920px;
			margin: 0 auto;
			height: 742px;
			img{
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
		.data16Wz {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: end;
			flex-direction: column;

			.data16WzTil {
				font-size: 45px;
				
				font-weight: bold;
				color: #FFFFFF;
				margin-bottom: 61px;
				width: 776px;
				text-align: center;
			}

			.data16WzCen {
				font-size: 18px;
				
				font-weight: 300;
				color: #FFFFFF;
				width: 776px;
				margin-bottom: 78px;
				text-align: center;
				white-space: pre-line;
			}
		}

		.data16BgSp {
			width: 100%;
			height: 1080px;
			max-width: 1920px;
			margin: 0 auto;
			img {
				width: 100%;
				height: 1080px;
				object-fit: cover;
			}

			video {
				width: 100%;
				height: 1080px;
				object-fit: cover;
			}
		}

		.data16BgSpList {
			// height: 516px;
			// display: flex;
			// align-items: center;
			padding:160px 0 153px;
			// overflow-x: auto;
			width: 1200px;
			margin: 0 auto;
			.swiper-canpin{
				width: 1200px;
				overflow: hidden;
				.swiper-slide-Two{
					width: 277px ;
				}
			}
			.swiper-slide-Two:not(:last-child) {
				margin-right: 31px;
			}

			.data16BgSpListFor {
				width: 277px;
				height: 203px;
				// cursor: pointer;
				position: relative;

				img {
					width: 277px;
					height: 203px;
					object-fit: cover;
				}
			}
		}
	}

	.swiper-data2-banner {
		overflow: hidden;
	}
	@media screen and (max-width:1200px) {
		.data16{
			margin-top: -30px !important;
		}
		.data16Bg {
			min-width:100% !important;
			width:100% !important;
			margin-bottom: 30px !important;
			max-height:120vh !important;
			
			.data16Img{
				height: 50vh !important;
			}
			.data16WzTil{
				font-size: 36px !important;
				margin-bottom:30px !important;
				width: 100% !important;
			}
			.data16WzCen {
				margin-bottom:30px !important;
				width: 100% !important;
				font-size: 14px !important;
				padding: 0 30px !important;
				box-sizing: border-box;
			}
			.data16BgSp{
				height:50vh !important;
				img {
					height: 100% !important;
				}
				
				video {
					height:100% !important;
				}
			}
			.data16BgSpList {
				padding:20px !important;
				width:100% !important;
				overflow-x: auto;
				box-sizing: border-box;
				height: 20vh !important;
				margin-top: -30px;
			}
			.swiper-canpin{
				width: 100% !important;
				.swiper-slide-Two{
					width: 100px !important;
				}
			}
			.swiper-slide-Two:not(:last-child) {
				margin-right: 10px !important;
			}
			.data16BgSpListFor {
				height: calc(20vh - 70px) !important;
				img{
					width: 100px !important;
					height: 100% !important;
					object-fit: contain !important;
				}
			}
		}
	}
</style>